export default {
  meta: {
    title: '加盟商报表',
    url: '/expandstore/reportfranchise' // 埋点用，记录所属模块
  },
};
